// constants

// action_component_subject
const SET_LOGIN = "SET_LOGIN";
const REMOVE_LOGIN = "REMOVE_LOGIN";

// reducers

const initialState = {};

const LoginReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_LOGIN:
			return { ...action.payload };

		case REMOVE_LOGIN:
			return {};

		default:
			return state;
	}
};

export default LoginReducer;

// actions

// const resolveAfter2Seconds = () => {
// 	return new Promise((resolve) => {
// 		setTimeout(() => {
// 			resolve("resolved");
// 		}, 2000);
// 	});
// };

// // action_component_subject
// export const decrementTestCounter = () => async (dispatch) => {
// 	const result = await resolveAfter2Seconds();
// 	console.log(result);
// 	dispatch({
// 		type: INCREMENT_TEST_COUNTER,
// 	});
// };

// // action_component_subject, prefix set(not update),empty(not remove),hide,show
// export const incrementTestCounter = () => {
// 	return {
// 		type: INCREMENT_TEST_COUNTER,
// 	};
// };

export const setLogin = (payload) => {
	return {
		type: SET_LOGIN,
		payload: payload,
	};
};

export const logout = () => {
	return {
		type: REMOVE_LOGIN,
	};
};
